module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.2-application-management.efb8ed9b.png";